
export const navLinks = [
  { title: 'Services', dropdown: true, link: false },
  { title: 'Gallery', dropdown: false, link: true },
  { title: 'Reviews', dropdown: false, link: true },
  { title: 'About', dropdown: false, link: false },
  { title: 'Contact', dropdown: false, link: false }
]